<template>
  <div class="contract-device-bd">
    <div class="change-title ub ub-sp" v-if="stateCodeDic.zlz">
      <el-radio-group v-model="formSearch.deviceState" @change="onPageChange({ page: 1 })">
        <el-radio-button :label="stateCodeDic.dfh">{{ $t('crm_contract_device_sale.dai_fa_huo') }} ({{ countDetail[stateCodeDic.dfh] || 0 }})</el-radio-button>
        <el-radio-button :label="`${stateCodeDic.ztz},${stateCodeDic.dxs}`">
          {{ $t('crm_contract_device_sale.dai_gou_ji') }} ({{ (+countDetail[stateCodeDic.ztz] || 0) + (+countDetail[stateCodeDic.dxs] || 0) }})
        </el-radio-button>
        <el-radio-button :label="stateCodeDic.ygh">{{ $t('crm_contract_device_sale.yi_geng_huan') }} ({{ countDetail[stateCodeDic.ygh] || 0 }})</el-radio-button>
        <el-radio-button :label="stateCodeDic.ywy">{{ $t('crm_contract_device_sale.yi_wei_yue') }} ({{ countDetail[stateCodeDic.ywy] || 0 }})</el-radio-button>
        <el-radio-button :label="stateCodeDic.ygj">{{ $t('crm_contract_device_sale.yi_gou_ji') }} ({{ countDetail[stateCodeDic.ygj] || 0 }})</el-radio-button>
      </el-radio-group>
      <search-input v-model="formSearch.search" :placeholder="$t('crm_contract_device_sale.qsrsbjsh')" @fetch="onPageChange({ page: 1 })"></search-input>
    </div>
    <div class="search-hd" style="padding-top: 0" v-if="formSearch.deviceState === stateCodeDic.ygj && funcView.sales_contract_buy_sim_data && detail.partyAId && detail.partyAId == userInfo.rootOrgId">
      <el-button type="primary" @click="buyDataService(tableSelect)" :disabled="!tableSelect.length">
        <i class="icon icon-add"></i>
        &ensp;
        <span>{{ funcView.sales_contract_buy_sim_data }}</span>
      </el-button>
    </div>
    <div class="table-bd" v-if="formSearch.deviceState">
      <!-- 待发货 -->
      <custom-table
        key="1"
        index
        v-if="detail.afterServiceId == detail.partyAId && formSearch.deviceState === `${stateCodeDic.dfh}`"
        :data="tableList"
        tableCode="contract_sales_tab_device1"
      ></custom-table>
      <custom-table
        key="2"
        index
        v-if="detail.afterServiceId != detail.partyAId && formSearch.deviceState === `${stateCodeDic.dfh}`"
        :data="tableList"
        tableCode="contract_sales_tab_device2"
      ></custom-table>
      <!-- 待购机 -->
      <custom-table
        key="3"
        index
        v-if="formSearch.deviceState === `${stateCodeDic.ztz},${stateCodeDic.dxs}`"
        :data="tableList"
        tableCode="contract_sales_tab_device3"
        :slots="['action']"
        :filterArr="['imsi', 'simState', 'unitPrice', 'changeDate', 'saleStartTime', 'breakTime', 'newBodyNum', 'afterServiceEndTime', 'simServiceEndTime']"
      >
        <template slot="action" slot-scope="scope">
          <span></span>
          <!-- 收货（售后公司和乙方可以）-->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.contractDetail_partybReceive && rule.partybReceive && `${scope.row.bizState}` === `${stateCodeDic.ztz}` && bizClass"
            @click="handleDeviceRecevice(scope.row)"
          >
            {{ $t('crm_contract_device_sale.shou_huo') }}
          </el-button>
          <!-- 售卖（只有售后和乙方可以确认售卖）-->
          <el-button
            type="text"
            size="mini"
            v-if="funcView.contractDetail_device_sale && rule.sales && `${scope.row.bizState}` === `${stateCodeDic.dxs}` && bizClass && scope.row.hqReceiveState"
            @click="handleDeviceSale(scope.row)"
          >
            {{ $t('crm_contract_device_sale.que_ren_shou_mai') }}
          </el-button>
        </template>
      </custom-table>
      <!-- 已更换 -->
      <custom-table
        key="4"
        index
        v-if="formSearch.deviceState === stateCodeDic.ygh"
        :data="tableList"
        tableCode="contract_sales_tab_device3"
        :filterArr="['imsi', 'simState', 'unitPrice', 'shipmentTime', 'deliveryTime', 'saleStartTime', 'breakTime', 'newBodyNum', 'action', 'afterServiceEndTime', 'simServiceEndTime', 'hqReceiveState']"
      ></custom-table>
      <!-- 已违约 -->
      <custom-table
        key="5"
        index
        v-if="formSearch.deviceState === stateCodeDic.ywy"
        :data="tableList"
        tableCode="contract_sales_tab_device3"
        :filterArr="['imsi', 'simState', 'unitPrice', 'shipmentTime', 'deliveryTime', 'bizState', 'changeDate', 'newBodyNum', 'action', 'afterServiceEndTime', 'simServiceEndTime', 'hqReceiveState']"
      ></custom-table>
      <!-- 已购机 -->
      <custom-table
        key="6"
        index
        type="checkbox"
        v-model="tableSelect"
        v-if="formSearch.deviceState === stateCodeDic.ygj"
        :data="tableList"
        tableCode="contract_sales_tab_device3"
        :filterArr="['bizState', 'changeDate', 'shipmentTime', 'deliveryTime', 'breakTime', 'newBodyNum', 'hqReceiveState']"
      >
        <template slot="action" slot-scope="scope">
          <span></span>
          <!-- 购买数据服务-->
          <el-button
            type="text"
            size="mini"
            v-if="(scope.row.simState == '0' || scope.row.simState == '10' || scope.row.simState == '20') && detail.partyAId  && detail.partyAId == userInfo.rootOrgId && funcView.sales_contract_buy_sim_data"
            @click="buyDataService([scope.row])"
          >
            {{ formatRow(scope.row) }}
            {{ funcView.sales_contract_buy_sim_data }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 合同变更弹窗 -->
    <approval-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></approval-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';

export default {
  components: { approvalDialog },
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    rule: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tableSelect: [],
      dialogVisible: false,
      dialogModel: {},
      contractStatus: 'all',
      stateCodeDic: {},
      countDetail: {},
      bizClass: '',
      formSearch: {
        isCheckBill: false,
        bizId: '',
        deviceState: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
      classMap: {
        leasing_contract: 20, // 租赁合同
        lease_renewal_contract: 21, // 续租租赁
        frame_contract: 30, // 框架协议
        frame_order: 31, // 协议订单
        trail_order: 10, // 试用订单
      },
    };
  },
  computed: {
    // 是否总部
    userInfo() {
      return this.$store.state.userInfo || {};
    },
  },
  mounted: function () {
    this.formSearch.bizId = this.getJump('contractId');
    this.bizClass = this.getJump('contractClass');
    const approveType = this.getJump('approveType');
    if (approveType && !this.bizClass) {
      this.bizClass = this.classMap[approveType];
    }
    this.getTableCount();
    this.getFuncView();
    this.getDictionary('order_device_biz_state', (data) => {
      this.stateCodeDic = this.$listTransObject(data.order_device_biz_state, 'code', 'value');
      this.formSearch.deviceState = `${this.stateCodeDic.ztz},${this.stateCodeDic.dxs}`;
      this.getTableList();
    });
    this.Bus.$on('contract_device', () => {
      this.getTableCount();
      this.getTableList();
    });
  },
  methods: {
    formatRow(row) {
      row.isExists = false;
    },
    // 获取表格数据列表
    getTableList: function () {
      this.tableList = [];
      this.totalRows = null;
      // 是否是待发货
      const isWait = this.formSearch.deviceState === this.stateCodeDic.dfh;
      const isSame = this.detail.afterServiceId === this.detail.partyAId;
      if (isWait && !isSame) {
        this.$getJSON(apis.saleOrderListScheme, { bizId: this.formSearch.bizId, bizClass: this.bizClass }).then((res) => {
          this.tableList = res.data.goodsList || [];
          this.totalRows = null;
        });
        return;
      }
      this.formSearch.isCheckBill = this.formSearch.deviceState === `${this.stateCodeDic.ztz},${this.stateCodeDic.dxs}`;
      this.$getJSON(apis.saleOrderDevicePage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.breakTime = item.changeDate;
          item.isExists = true;
        });
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 获取表格数据数量
    getTableCount: function () {
      this.$getJSON(apis.saleOrderDeviceCount, { bizId: this.formSearch.bizId }).then((res) => {
        this.countDetail = res.data || {};
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 收货
    handleDeviceRecevice: function (item) {
      this.$confirm(this.$t('crm_contract_device_sale.nqdydgspzshczm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          const deviceList = [
            {
              bodyNum: item.bodyNum,
              deviceId: item.deviceId,
              productCode: item.productCode,
            },
          ];
          this.$postJSON(apis.contractReceive, {
            bizId: this.formSearch.bizId,
            bizClass: this.bizClass,
            deviceList: deviceList,
            operateType: 2,
          }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.tableList = [];
            this.totalRows = 0;
            this.getTableList();
            this.getTableCount();
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
    // 确认售卖
    handleDeviceSale: function (item) {
      this.$confirm(this.$t('crm_contract_device_sale.nqdysmgsbm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          this.$postJSON(`${apis.SaleOrderConfirmSale}`, { orderDeviceId: item.orderDeviceId }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
            this.getTableCount();
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
    // 下发账单
    onSendBill: function (item) {
      this.$confirm(this.$t('crm_contract_device_sale.nqdydgsbzxfzdczm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          this.$postJSON(`${apis.deviceFeignCommandTask}/${item.orderId}/${item.deviceNo}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            // this.getTableList();
            // this.getTableCount();
            // this.$emit('success');
          });
        })
        .catch(() => {});
    },
    // 恢复使用
    recoveryUse: function (item) {
      this.$confirm(this.$t('crm_contract_device_sale.nqdydgsbzhfsyczm'), this.$t('Common.com_reminder'), {
        confirmButtonText: this.$t('Common.com_confirm'),
        cancelButtonText: this.$t('Common.com_cancel'),
        closeOnClickModal: false,
        type: 'warning',
      })
        .then(() => {
          this.$postJSON(`${apis.contractEndPauseUse}/${this.formSearch.bizId}/${item.deviceId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
            this.getTableCount();
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
    // 购买数据服务
    buyDataService: function (rows) {
      this.dialogModel.type = 'add';
      this.dialogModel.changeType = 'buy_data_service';
      this.dialogModel.row = { orderId: rows[0] && rows[0].orderId, deviceIdList: rows.map(t => t.deviceId) };
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.contract-device-bd {
  background-color: #ffffff;
  padding: 0 24px;
  .change-title {
    padding: 24px 0;
  }
}
</style>
